import type { IntlShape } from 'react-intl';

import type { TodoState } from './types';

/**
 * Plan card header: the plan's own title, else the chat title, else a generic
 * fallback. Shared by the approval card and the live card so the two can never
 * drift — approving morphs one into the other in place.
 */
export const planCardTitle = (
  state: TodoState,
  intl: IntlShape,
  chatTitle?: string
): string =>
  state.planTitle ??
  chatTitle ??
  intl.formatMessage({ defaultMessage: 'Plan', id: 'fz0z4cb6fQ' });
